

module.exports = __webpack_require__.stylable.create(
    "noresults4007592660",
    {"classes":{"root":"noresults4007592660__root","container":"noresults4007592660__container","innerContainer":"noresults4007592660__innerContainer","fullButton":"noresults4007592660__fullButton","hollowButton":"noresults4007592660__hollowButton","text":"noresults4007592660__text"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    8,
    "noresults4007592660",
    null
);
